export const environment = {
	production: true,
	context: 'development',
	platform: 'hub',
	gatewayUrl: 'https://portal.dce.dev.my.visiativ.com/api/',
	surveyLink: 'https://room.myfeelback.com/website/5uzjb2ex7JO1C1c09/form/61856/12500',
	dssUserFirstname: 'Plateformes clients',
	dssUserLastname: '(DSS API)',
	dssUserSalesforceId: '005AX000000LYFZYA4',
	adminSalesforceID: '005AP000006AZgzYAG',
	adminFirstname: 'Robot',
	adminLastname: 'VISIATIV',
	userSFEmailFirstname: 'Data',
	userSFEmailLastname: 'Integration',
	userSFEmailSalesforceID: '005AX000000L37eYAC',
	emailSFAdminAdress: 'customercare-dev@visiativ.com',
	originCase: 'Web Portail Client',
	adb2cClientId: '37b1367b-d465-425a-9de4-1c5a5fd21cf1',
	adb2cChangePasswordEndpoint:
		'https://visiativcustomerdev.b2clogin.com/visiativcustomerdev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_CHANGE_PWD_IDENTITY',
	allowedLangs: ['en', 'fr', 'de', 'pl', 'nl'],
	marginTopContractPanel: '24px',
	helpdeskContainerHeight: '100%',
	trainingCatalogFilters: ['hub', 'web'],
	supportRequestCaseNumber: 3,
	workspaceID: 'zdWCmFd0YeWZWfat', //product-fruits
};
